import type { ReactNode } from "react";

import clsx from "clsx";

import * as css from "./Balloon.module.css";

export type BalloonTailPosition =
    | "TopLeft"
    | "TopRight"
    | "TopCenter"
    | "BottomLeft"
    | "BottomRight"
    | "BottomCenter";

export interface IBalloon {
    children?: ReactNode;
    isOpen: boolean;
    tailPosition?: BalloonTailPosition;
    onMouseEnter?: (event: React.MouseEvent<HTMLElement>) => void;
    onMouseLeave?: (event: React.MouseEvent<HTMLElement>) => void;
}
const getBalloonTailPositionClassname = (pos?: BalloonTailPosition) => {
    switch (pos) {
        case "BottomLeft":
            return css.bottomLeft;
        case "BottomRight":
            return css.bottomRight;
        case "BottomCenter":
            return css.bottomCenter;
        case "TopCenter":
            return css.topCenter;
        case "TopRight":
            return css.topRight;
        case "TopLeft":
            return css.topLeft;
        default:
            return null;
    }
};

const Balloon = (props: IBalloon) => {
    const isBottom = props.tailPosition.startsWith("Bottom");

    return (
        <div className={css.balloonComponent}>
            {props.isOpen && (
                <div
                    className={clsx(css.balloonContent, isBottom && css.alignTop)}
                    onMouseEnter={props.onMouseEnter}
                    onMouseLeave={props.onMouseLeave}
                >
                    <div className={clsx(css.tail, getBalloonTailPositionClassname(props.tailPosition))} />
                    {props.children}
                </div>
            )}
        </div>
    );
};

export default Balloon;
